import { BasicSimulationVariableInterface } from '../_models/simulation-variable-interfaces';

export type AlignmentString = 'center' | 'top' | 'right' | 'bottom' | 'left';

export function isPlainBasicSimulationVariable(value: any): value is BasicSimulationVariableInterface {
  const keys = Object.keys(value);
  return keys.includes('value') && keys.includes('unit');
}
